import axios from 'axios';

export default {
    state: {
        users: [],
        total: 0,
        loading: false,
        currentUser: null
    },
    getters: {
        currentUserID: (state) => state.currentUser 
    },
    mutations: {
        SET_USERS(state, users) {
            state.users = users;
        },
        ADD_USER(state, user) {
            state.users.unshift(user);
        },
        SET_TOTAL(state, total) {
            state.total = total;
        },
        SET_LOADING(state, val) {
            state.loading = val;
        },
        SET_CURRENT_USER(state, val) {
            state.currentUser = val
        }
    },
    actions: {
        getAllUsers({ commit }, params) {
            commit('SET_LOADING', true);
            axios.get('api/user/all', {
                params
            }).then( response => {
                if (response?.data?.users) {
                    commit('SET_USERS', response.data.users);
                    commit('SET_TOTAL', response.data.total);
                }                
                commit('SET_LOADING', false);
            }, error => {
                console.log(error);
                commit('SET_LOADING', false);
            })
        },
        addUser({ commit }, user) {
            commit('ADD_USER', user);
        },
         // eslint-disable-next-line
        deleteUser({ }, data) {
            return new Promise((resolve, reject) => {
                axios({ url: '/api/user/delete', data, method: 'POST' })
                  .then((resp) => {
                    resolve(resp);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
        },
         // eslint-disable-next-line
        makeDbDump({ }) {
            return new Promise((resolve, reject) => {
                axios({ url: '/api/user/make-db-dump', method: 'POST' })
                  .then((resp) => {
                    resolve(resp);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
        },
         // eslint-disable-next-line
         synchroniseDatabases({ }, data) {
            return new Promise((resolve, reject) => {
                axios({ 
                        url: '/api/user/sync-databases', 
                        method: 'POST',  
                        data
                })
                  .then((resp) => {
                    resolve(resp);
                  })
                  .catch((err) => {
                    reject(err);
                  });
              });
        },
        setCurrentUser({ commit }, data) {
            commit('SET_CURRENT_USER', data)
        }
    }
}